export const configEduLevels = {
    1: 'Подготовка квалифицированных рабочих, служащих',
    2: 'Программа подготовки специалистов среднего звена',
    3: 'Бакалавриат',
    24: 'Базовое высшее образование',
    4: 'Магистратура',
    25: 'Специализированное высшее образование',
    5: 'Специалитет',
    6: 'Аспирантура',
    7: 'Адъюнктура',
    9: 'Ассистентура - стажировка',
    8: 'Ординатура',
    22: 'Интернатура',
    13: 'Дополнительная общеразвивающая программа',
    14: 'Дополнительная предпрофессиональная программа',
    15: 'Дополнительная предпрофессиональная программа в сфере искусств',
    23: 'Дополнительная предпрофессиональная программа в сфере физической культуры и спорта',
    16: 'Повышение квалификации',
    17: 'Профессиональная переподготовка',
    10: 'Профессиональная подготовка по профессиям рабочих, должностям служащих',
    11: 'Переподготовка рабочих, служащих',
    12: 'Повышение квалификации рабочих, служащих',
    18: 'Дошкольное образование',
    19: 'Начальное общее образование',
    20: 'Основное общее образование',
    21: 'Среднее общее образование',
};

export const configEduLevelsTranslateMap = {
    1: 'edu_levels.training_of_qualified_workers',
    2: 'edu_levels.secondary_vocational_training',
    3: 'edu_levels.bachelor_degree',
    24: 'edu_levels.basic_higher_education',
    4: 'edu_levels.master_degree',
    25: 'edu_levels.specialized_higher_education',
    5: 'edu_levels.specialist_degree',
    6: 'edu_levels.postgraduate_studies',
    7: 'edu_levels.military_postgraduate',
    9: 'edu_levels.assistant_internship',
    8: 'edu_levels.medical_residency',
    22: 'edu_levels.medical_internship',
    13: 'edu_levels.general_development_program',
    14: 'edu_levels.pre_professional_program',
    15: 'edu_levels.arts_pre_professional_program',
    23: 'edu_levels.sports_pre_professional_program',
    16: 'edu_levels.professional_development',
    17: 'edu_levels.professional_retraining',
    10: 'edu_levels.vocational_training',
    11: 'edu_levels.worker_retraining',
    12: 'edu_levels.worker_qualification_improvement',
    18: 'edu_levels.preschool_education',
    19: 'edu_levels.primary_education',
    20: 'edu_levels.basic_education',
    21: 'edu_levels.secondary_education',
};
